import type { FunctionComponent } from 'react'

import styles from './comparison-table.module.scss'
import { DesktopComaprisonTable } from './desktop-comparison-table'
import { MobileComaprisonTable } from './mobile-comparison-table'
import type { ComparisonTableFragment } from '@graphql/fragments/ComparisonTableFragment.graphql'

/**
 * A component that displays a table to compare different products, plans, features, benefits, etc...
 */
const ComparisonTable: FunctionComponent<
    Omit<ComparisonTableFragment, 'type' | 'sys'>
> = (props) => (
    <div className={styles.section}>
        <div className={styles.outer}>
            <div className={styles.inner}>
                <DesktopComaprisonTable {...props} />
                <MobileComaprisonTable {...props} />
            </div>
        </div>
    </div>
)

export default ComparisonTable
